export { JobPostedOnText } from './JobPostedOnText';
